import React from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { selectSettings } from "../../store/slices/settingsSlice";
import { buildClubSchema } from "./clubSchema";

// Fields come from the club's real settings columns (see clubSchema.ts).
const OrganizationSchema: React.FC = () => {
  const settings: any = useSelector(selectSettings);
  const schema = buildClubSchema(settings, "SportsActivityLocation");

  if (!schema) return null;

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default OrganizationSchema;
